import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { makePlainObject } from '../../utils';

class CurrentUser
{
    username = '';
    email = '';
    is_staff = false;
    is_active = false;
}

const initialUser = makePlainObject(new CurrentUser());

const loginState =
{
    currentUser: initialUser,
};

export type LoginState = typeof loginState;

export const loginSlice = createSlice(
{
    name: 'login',
    initialState: loginState,
    reducers:
    {
        setCurrentUser: function(state, action: PayloadAction<CurrentUser|null>)
        {
            state.currentUser = action.payload ?? makePlainObject(new CurrentUser());
        },
        setCurrentUserName: function(state, action: PayloadAction<string>)
        {
            state.currentUser.username = action.payload;
        },
        setCurrentUserEmail: function(state, action: PayloadAction<string>)
        {
            state.currentUser.email = action.payload;
        }
    },
});

export const loginActions = loginSlice.actions;
export const loginReducer = loginSlice.reducer;